import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'ui-lib/components/Button';
import Link from 'ui-lib/components/Link';
import { createSx } from 'ui-lib/utils';

const sx = createSx({
  link: {
    alignSelf: 'flex-end',
  },
});

const ForgotPasswordButton = () => {
  const { t } = useTranslation();

  return (
    <Link to='/forgot-password' sx={sx.link}>
      <Button
        type='button'
        variant='text'
        testID='forgot-password-button'
      >
        {t('auth.label_forgotPassword')}
      </Button>
    </Link>
  );
};

export default ForgotPasswordButton;
